<template>
  <div class="callMeBox">
    <div>
      <el-tooltip content="admin@yjz-buyer.com"  placement="left" effect="light">
        <img @click="handleEmail()" src="@/assets/fonts/emailCall.svg" alt="">
      </el-tooltip>
      <el-tooltip content="+86 15008483891"  placement="left" effect="light">
        <img @click="handleWhatsapp()" src="@/assets/fonts/whatsappCall.svg" alt="">
      </el-tooltip>
      <el-tooltip content="+86 15008483891" placement="left" effect="light">
        <img src="@/assets/fonts/weixin.svg" alt="">
      </el-tooltip>
      <el-tooltip content="286984025" placement="left" effect="light">
        <img @click="handleQQ()" src="@/assets/fonts/qq.svg" alt="">
      </el-tooltip>
      
      <div @click="handleUp" class="goTop">
        <img src="@/assets/fonts/goTop.svg" alt="">
      </div>
    </div>
    <!-- <div class="talkMeBox">
      <div>Problem not solved yet ? Talk to the boss!</div>
      <div>
        <img src="@/assets/img/emailIcon.png" alt="">
        <div>123456789@qq.com</div>
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {
    methods: {
      handleUp() {
        //优化一下
        if (document.documentElement.scrollTop > 0) {
          let timer = setInterval(() => {
            document.documentElement.scrollTop -= 100
            if (document.documentElement.scrollTop <= 0) {
              clearInterval(timer)
            }
          }, 10)
        }
      },
      handleQQ() {
        window.location.href = 'tencent://message/?uin=286984025&Site=&Menu=yes'
        // const link = document.createElement('a');
        // link.href = `tencent://message/?uin=${this.qqNumber}&Site=&Menu=yes`;
        // link.click();
      },
      handleEmail() {
        window.location.href = 'mailto:admin@yjz-buyer.com'
      },
      handleWhatsapp() {
        window.open(`https://wa.me/+8615008483891?text=hello`, '_blank');
      },
    }
  }
</script>

<style lang="scss" scoped>
.callMeBox {
  >div:nth-child(1){
    position: fixed;
    bottom: 70px;
    right: 2%;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 601;
    img{
      width: 35px;
      cursor: pointer;
      margin-bottom: 3px;
    }
    .goTop{
      margin-top: 10px;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      background: #f6b010;
      img{
        width: 35px;
        height: 30px;
      }
    }
  }
  @media screen and (min-width: 1024px) {
    .talkMeBox{
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
  .talkMeBox{
    position: fixed;
    bottom: 5%;
    right: 5%;
    background: #fff;
    box-shadow: 0px 0px 27px 0px rgba(0, 0, 0, 0.1);
    border-radius: 50px;
    padding: 10px 10px 10px 30px;
    z-index: 600;
    font-weight: 600;
    >div:nth-child(2){
      display: flex;
      justify-content: center;
      align-items: center;
      >img{
        width: 24px;
        height: 18px;
        margin-right: 5px;
        cursor: pointer;
      }
      >div{
        font-size: 14px;
        color: #45AAE7;
      }
    }
  }
}
</style>